export const parseResponseErrorMessage = (response: any): string => (
  response.data?.data?.length
    ? response.data.data.map(it => it.message).join('\n')
    : response.data.message || ''
)